"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChainName = exports.useSwitchChain = void 0;
const constants_1 = require("../utils/constants");
const helper_1 = require("../utils/helper");
function useSwitchChain() {
    const switchChain = (chainName) => {
        if (window.parent) {
            const message = JSON.stringify({
                success: true,
                type: constants_1.eventTypes.switchChain,
                data: { chainName },
            });
            window.parent.postMessage(message, document.referrer);
        }
    };
    return { switchChain };
}
exports.useSwitchChain = useSwitchChain;
function useChainName() {
    var _a, _b, _c, _d;
    if ((0, helper_1.triaConnected)()) {
        const chainName = window.localStorage.getItem(constants_1.TRIA_WALLET_SELECTED_CHAIN);
        return { chainName };
    }
    else if ((0, helper_1.wagmiConnected)()) {
        const wagmiStore = localStorage.getItem('wagmi.store');
        if (wagmiStore) {
            const chainId = (_d = (_c = (_b = (_a = JSON.parse(wagmiStore)) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.chain) === null || _d === void 0 ? void 0 : _d.id;
            const chainName = constants_1.chainIdToChainName[chainId];
            return { chainName };
        }
        else
            return { chainName: null };
    }
    else
        return { chainName: null };
}
exports.useChainName = useChainName;
